import { useEffect, useRef } from "react";
import { useIntl } from "react-intl";

export function useOnLanguageChange(callback: (locale: string) => void) {
  const { locale } = useIntl();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; 
    }
    callback(locale);
  }, [locale]);
}
